export const getNumber = (idx) => idx?.toString().padStart(4, "0");
